import React from 'react'
import SealProductPage from './SealProductPage'
import MetallicsealOne from "../asset/metallicseal/1.png"
import MetallicsealTwo from "../asset/metallicseal/2.png"

const MetallicFaceSeals = () => (
  <SealProductPage
    title='Metallic Face Seals'
    imageAlt='Metallic face seal'
    images={[MetallicsealOne, MetallicsealTwo]}
    description='The Metallic Face Seal and K Seal is manufactured from age-hardened Inconel X-750 material, designed for leak-tight water sealing at 200 kg/cm² pressure and 500°C temperature. Precisely crafted with dimensions controlled within 0.003mm, it ensures strength and flexibility. The seal’s design, developed by HARDCOATS, incorporates fatigue analysis, contact stress considerations, and a self-energizing philosophy. Our innovative manufacturing technology achieves a surface finish of 0.1 micron and a groove thickness of 0.25 mm, meeting the most stringent performance requirements.'
  />
)

export default MetallicFaceSeals
